import { render, staticRenderFns } from "./BalanceModal.vue?vue&type=template&id=187b0ad1&scoped=true"
import script from "./BalanceModal.vue?vue&type=script&lang=js"
export * from "./BalanceModal.vue?vue&type=script&lang=js"
import style0 from "./BalanceModal.vue?vue&type=style&index=0&id=187b0ad1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187b0ad1",
  null
  
)

export default component.exports